import { ListOrdered } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

const ItemSalesReport = ({ data }: any) => {
    const { t } = useTranslation();

    return (
        <table className="w-full border-collapse border border-slate-300 text-right">
            <thead>
                <tr className="bg-slate-100">
                    <th className="border border-slate-300 px-4 py-3 text-sm font-bold">{t("item_name")}</th>
                    <th className="border border-slate-300 px-4 py-3 text-sm font-bold">{t("item_price")}</th>
                    <th className="border border-slate-300 px-4 py-3 text-sm font-bold">{t("total_quantity")}</th>
                    <th className="border border-slate-300 px-4 py-3 text-sm font-bold">{t("accountname")}</th>
                </tr>
            </thead>
            <tbody className="text-slate-700">
                {data?.length > 0 ? (
                    data?.map((group: any, gIdx: number) => {
                        const details = group.details || [];
                        return (
                            <React.Fragment key={gIdx}>
                                {group?.details?.map((detail: any, dIdx: number) => {
                                    const isFirstAppearanceOfAccount = dIdx === 0 || details[dIdx].account_name !== details[dIdx - 1].account_name;
                                    let accountRowSpan = 0;
                                    if (isFirstAppearanceOfAccount) {
                                        for (let i = dIdx; i < details.length; i++) {
                                            if (details[i]?.account_name === detail?.account_name) {
                                                accountRowSpan++;
                                            } else {
                                                break;
                                            }
                                        }
                                    }
                                    return (
                                        <tr key={`${gIdx}-${dIdx}`} className="hover:bg-slate-50 transition-colors">
                                            {dIdx === 0 && (
                                                <>
                                                    <td
                                                        rowSpan={group.details.length}
                                                        className={`border border-slate-300 px-4 py-2 text-sm ${group?.details?.length > 1 ? "bg-indigo-50 text-indigo-900" : "bg-white"}`}
                                                    >
                                                        {group.item_name}
                                                    </td>
                                                    <td
                                                        rowSpan={group.details.length}
                                                        className={`border border-slate-300 px-4 py-2 text-sm ${group?.details?.length > 1 ? "bg-indigo-50 text-indigo-900" : "bg-white"}`}
                                                    >
                                                        {Number(group.item_price || 0).toFixed(2)}
                                                    </td>
                                                    <td
                                                        rowSpan={group.details.length}
                                                        className={`border border-slate-300 px-4 py-2 text-sm ${group?.details?.length > 1 ? "bg-indigo-50 text-indigo-900" : "bg-white"}`}
                                                    >
                                                        {group.total_quantity}
                                                    </td>
                                                </>
                                            )}

                                            {isFirstAppearanceOfAccount && (
                                                <td rowSpan={accountRowSpan}
                                                    className="border border-slate-300 px-4 py-2 text-sm">
                                                    {detail?.account_name}
                                                </td>
                                            )}

                                        </tr>
                                    )
                                }
                                )}
                            </React.Fragment>
                        )
                    })
                ) : (
                    <tr>
                        <td colSpan={4} className="py-20 text-center border border-slate-300">
                            <div className="flex flex-col items-center opacity-20">
                                <ListOrdered size={48} />
                                <p className="text-sm font-bold mt-2">{t("No Data Found")}</p>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default ItemSalesReport;